export default __webpack_public_path__ + "static/media/Yarn-Logo.20176999.svg";